import { useEffect, useState } from 'react';

import { BrowserUtils } from 'utils';

export const useCookiesAllowed = () => {
    const [areCookiesAllowed, setCookiesAllowed] = useState(true);

    useEffect(() => {
        setCookiesAllowed(BrowserUtils.areCookiesAllowed());
    }, []);

    return areCookiesAllowed;
};
